import { render, staticRenderFns } from "./CharacterItem.vue?vue&type=template&id=555f7ac3&scoped=true&"
import script from "./CharacterItem.vue?vue&type=script&lang=js&"
export * from "./CharacterItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555f7ac3",
  null
  
)

export default component.exports